import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, Tombamento } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PlacaService extends BaseResourceService<Tombamento> {

  constructor(
    protected injector: Injector
  ) {
    super(`tombamentos/proxima-placa`, injector);
  }

  public filtrar(pagina: number, limite: number, filtros: {}): Observable<any> {
    return this.http.get(`${this.login.cidade.id}/${this.api}/${pagina}/?orgao.id=${this.login.orgao.id}&relations=produto`, this.httpOptions()).pipe(
      map(res => res),
      catchError(err => this.handleError(err))
    );
  }

  public obterPorPlaca(): Observable<any> {
    return this.http.get<Tombamento>(
        `${this.login.cidade.id}/${this.api}?orgao=${this.login.orgao.id}`,
        this.httpOptions()).pipe(
            map(res => res),
    catchError(err => this.handleError(err))
  );
}

}
